import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const Logo = styled(motion.img)`
  width: 100%;
  object-fit: contain;
  height: 40px;
  margin-bottom: 24px;
  pointer-events: none;
  user-select: none;
`;

export const SwitchEmailOrPhoneContainer = styled(motion.div)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-size: 12px;
  font-weight: normal;
  margin-top: 12px;

  span:first-child {
    color: var(--pcm-body-color-secondary);
  }
  span:last-child {
    color: var(--pcm-accent-color);
    cursor: pointer;
  }
`;
